import { zExt } from "@redotech/redo-model/common/zod-util";
import { z } from "zod/v4";

export const getTnplContractForOrder = {
  name: "getTnplContractForOrder" as const,
  input: z.object({ orderId: zExt.objectId() }),
  output: z.object({
    hasTnplContract: z.boolean(),
    eligibleTnplLineItems: z.array(z.string()),
  }),
};
